module.exports = __webpack_public_path__ + "static/media/img_onboarding_header_bg4.14b38fe8.png";